export default __webpack_public_path__ + "static/media/FillProfile.474ae512.svg";